import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Enterprise } from 'src/models/Enterprise';

export interface IPartnerEnterpriseState {
  partnerEnterprise?: Enterprise;
  latestModificationOnUTC?: Date;
}

// Todo: Utility not initialized yet "Uncaught ReferenceError: Cannot access 'Utility' before initialization"
function getStore<T>(
  key: 'partnerEnterprise' | 'partnerEnterpriseLatestModificationOnUTC'
): T | undefined {
  const value = sessionStorage.getItem(key) || localStorage.getItem(key);

  if (!value) {
    return undefined;
  }

  try {
    const parsedValue = JSON.parse(value, (key, val) => {
      const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

      if (typeof val === 'string' && iso8601Regex.test(val)) {
        return new Date(val);
      }

      return val;
    }) as T;

    return parsedValue;
  } catch (error) {
    // Todo: log error
    return undefined;
  }
}

export const initialPartnerEnterpriseState: IPartnerEnterpriseState = {
  partnerEnterprise: getStore<Enterprise>('partnerEnterprise'),
  latestModificationOnUTC: getStore<Date>(
    'partnerEnterpriseLatestModificationOnUTC'
  ),
};

export const selectPartnerEnterpriseState =
  createFeatureSelector<IPartnerEnterpriseState>('partnerEnterprise');

export const selectPartnerEnterprise = createSelector(
  selectPartnerEnterpriseState,
  (state) => state.partnerEnterprise
);
